import { useEffect, useState } from 'react'
import { storeInstance } from 'store/createStore'
import { getClientPublicKey } from 'store/modules/user-session/selectors'
import { useCustomerConfig } from 'hooks/useCustomerConfig'
import {
  CustomerConfigKey,
  pendingSupportContact,
  resolveSupportContact,
} from 'modules/customer-config'

export const useSupportContact = () => {
  const [clientPublicKey, setClientPublicKey] = useState<string>(
    () => getClientPublicKey(storeInstance.getState()) || ''
  )

  useEffect(() => {
    const sync = () => {
      const next = getClientPublicKey(storeInstance.getState()) || ''
      setClientPublicKey((prev) => (prev !== next ? next : prev))
    }
    const unsubscribe = storeInstance.subscribe(sync)
    sync()
    return unsubscribe
  }, [])

  const { data, isLoading } = useCustomerConfig(
    clientPublicKey,
    CustomerConfigKey.EMPLOYEE_EXPERIENCE__SUPPORT_CONTACT
  )

  if (isLoading) return pendingSupportContact()

  return resolveSupportContact(data)
}
